<template>
  <div
    class="form-group"
  >
    <div
      class="dropdown"
      :class="[containerClasses]"
      @mouseover="hovered = true" 
      @mouseleave="hovered = false">
      <template v-if="dropdown">
        <button
          class="btn btn-default btn-md dropdown-toggle"
          href="" 
          data-toggle="dropdown" 
          aria-haspopup="true"
          aria-expanded="false"
        >
          <label class="mr-2" v-if="title"> <b>{{title}}</b> </label> {{optionsSelectedLabel}}
        </button>
      </template>
      <template v-else>
        <div class="d-flex flex-row justify-content-between">
            <a data-toggle="collapse" 
              :href="accordian ? '#collapseSection' + cFieldId : ''" 
              role="button"
              aria-expanded="false"
              :aria-controls="'collapseSection' + cFieldId" 
              :class="{'not-a-link':!accordian, 'link-primary':accordian}"
            >
              <label v-if="label !== null" :class="[labelClasses]">
                <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip !== null&&tooltipLeft && !tooltipRight"></i>
                    {{ label }}
                <span style="padding-left: 5px;" v-if="accordian">
                  <i style="font-size: .75rem;" class="fas fa-angle-double-down"></i>
                </span>
                <span style="color:red">{{ required ? '*' : '' }}</span>
                <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip !== null && tooltipRight"></i>
              </label>
            </a>
        </div>   
      </template>
    
      <div :class="{'collapse':accordian, 'dropdown-menu':dropdown}" :id="'collapseSection' + cFieldId" style="min-width: 250px;padding:6px">
        <div style="overflow-y: auto;" :style="{'max-height': maxHeight}">
          <div style="padding-bottom: 3px; font-size:12px;">
            <a href="" @click.prevent="selectAllOptions"> All </a>
            |
            <a href="" @click.prevent="clearOptions"> Clear </a>
            <a href="" @click.prevent="newOptionClicked" 
              v-if="showNewOption"
              style="float:right">
              {{ newOptionLabel }}
            </a>
          </div>
          <div style="padding-right: 5px;padding-left: 5px; padding-bottom: 8px; font-size:12px; position: relative;" v-if="enableSearch || enableDBSearch">
            <input
              type="text"
              v-model="filterOptionsSearch"
              class="form-control form-control-sm rounded-right"
              placeholder="Search" aria-label="search"
              aria-describedby="search"
              @keydown.enter.prevent=""
              autocomplete="new-password"
            >
            <span class="icon-inside-sm"><i class="fa fa-search"></i></span>
          </div>
          
          <div class="form-check" 
            :class="{'form-check-inline': checkInLine}"
            v-for="(option, index) in this.enableSearch && !this.enableDBSearch ? filteredOptions : input_options"
            :key="'label-checkbox-option-' + index">
            <input 
              type="checkbox"
              class="form-check-input"
              :class="[computedValidationStatus]"
              :id="'checkbox-option_' + index + '-' + _uid"
              :name="'checkbox_array' + _uid"
              v-model="cValue"
              :value="option.value"
              :readonly="readOnly"
              :disabled="disabled"
              @click="onClick"
              @focus="onFocus"
              @blur="onBlur"
              @keypress="onKeyPress"
            />
            <label class="form-check-label" :for="'checkbox-option_' + index + '-' + _uid">
              <template v-if="!hasSlotLabel">
                {{ option.label }}
              </template>
              <slot name="optionLabel" :option="option"></slot>
            </label>
            <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
          </div>
        </div>
      </div>
  
      <div v-show="!cOpen && showSelectedOnClose && !dropdown">
        <div v-for="(value, index) in selectedValues" :key="'_show_selected_on_close_'+_uid+index">
          {{ value.label }}
        </div>
      </div>
  
      <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
      <div class="valid-feedback d-block" v-if="computedValidationStatus == 'is-valid'">
        <ul>
          <li v-for="(text, index) in validText" :key="_uid+'success_' + index">{{ text }}</li>
        </ul>
      </div>
      <div class="invalid-feedback d-block" v-if="computedValidationStatus == 'is-invalid'">
        <ul>
          <li v-for="(text, index) in invalidText" :key="_uid + 'error_' + index">{{ text }}</li>
        </ul>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import Vuex from 'vuex'
  import {selectorMixin} from './../mixins/index.js';
  
  export default {
    name: "multiple-select-field",
    mixins: [selectorMixin],
    props: {
      /*autoSubmit: {
        type: Boolean,
        default: false
      },*/
      title:{
        type: String,
        default: null
      },
      dropdown:{
        type: Boolean,
        default: false
      },
      showLimit: {
        type: Number,
        default: 2
      },
      placeholder: {
        type: String,
        default: null
      },
      value:{
        type:Array
      },
      enableSearch: {
        type: Boolean,
        default: true
      },
      enableDBSearch: {
        type: Boolean,
        default: false
      },
      open: {
        type: Boolean,
        default: false
      },
      fieldId: {
        type: String,
        default: null
      },
      maxHeight: {
        type: String,
        default: "650px"
      },
      checkInLine: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: String,
        default: null
      },
      tooltipIcon: {
        type: String,
        default: 'fas fa-question-circle'
      },
      tooltipRight: {
        type: Boolean,
        default: false
      },
      tooltipLeft: {
        type: Boolean,
        default: true
      },
      inLine: {
        type: Boolean,
        default: false
      },
      classes: {
        type: String,
        required: false
      },
      label: {
        type: String,
        default: null
      },
      options: {
        default: () => []
      },
      helpText: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      optionValue: {
        type: String,
        default: null
      },
      optionLabel: {
        type: String,
        default: null
      },
      optionFilter: {
        default: null
      },
      accordian: {
        type: Boolean,
        default: false
      },
      showNewOption: {
        type: Boolean,
        default: false
      },
      newOptionLabel: {
        type: String,
        default: "New"
      },
      /*showNullOption: {
        type: Boolean,
        default: false
      },
      nullOptionLabel:{
        type: String,
        default: "None"
      },*/
      showSelectedOnClose: {
        type: Boolean,
        default: false
      },
      sortOptionsBySelected:{
        type: Boolean,
        default: false
      }
    },
    watch: {
      input_options(newVal){
        this.filteredOptions = JSON.parse(JSON.stringify(newVal));
      },
      value: function(newVal, oldVal){
        if(JSON.stringify(newVal) != JSON.stringify(this.cValue)){
          this.cValue = JSON.parse(JSON.stringify(newVal));
        }
      },
      cValue: function(newVal, oldVal){
        if(this.sortOptionsBySelected){
          this.sortOptionsSelected();
        }
        this.$emit('input', newVal);
        this.$emit('onChange', this);
      },
      open(newVal){
        if(newVal) $("#collapseSection" + this.cFieldId).collapse('show');
        else $("#collapseSection" + this.cFieldId).collapse('hide');
        this.cOpen = newVal;
      }
    },
    computed: {
      ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
      hasSlotLabel() {
        return !!this.$slots.optionLabel;
      },
      selectedValues() {
        if(typeof this.cValue !== 'undefined'){
          return [...this.input_options.filter(option => this.cValue.includes(`${option.value}`)), ...this.input_options.filter(option => this.cValue.includes(option.value))];
        }else return [];
      },
      cFieldId() {
        return this.fieldId !== null ? this.fieldId : this._uid;
      },
      input_options() {
        try {
          let options = this.providerOptions.map((option) => {
            if (typeof option === 'object' && (option.value != undefined && option.label != undefined)) {
              return option;
            } else if (typeof option === 'object' && (this.optionLabel !== null && this.optionValue !== null)) {
              let aux = {value: option[this.optionValue], label: option[this.optionLabel], enabled: typeof option.__enabled!=='undefined'? option.__enabled:true};
              return aux;
            } else {
              let aux = {value: option, label: option};
              return aux;
            }
          });
          return options;
        } catch (err) {
          return [];
        }
      },
      hasSlotPrefix() {
        return !!this.$slots.prefix;
      },
      hasSlotSuffix() {
        return !!this.$slots.suffix;
      },
      slotClasses() {
        return this.hasSlotPrefix ? 'input-group-prepend' : this.hasSlotSuffix ? 'input-group-append' : null;
      },
      optionsSelectedLabel() {
          if (this.dropdown) {
              if (this.selectedValues.length == 0) {
                  return this.placeholder ? this.placeholder : "None selected";
              } else {
                  if (this.label) {
                      if (this.selectedValues.length > this.showLimit) {
                          return `${this.selectedValues.length} selected`;
                      } else {
                          return this.selectedValues.map(e => e.label ? e.label : '').join(", ");
                      }
                  } else {
                      return `${this.selectedValues.length} selected`;
                  }
              }
          } else {
              return this.placeholder ? this.placeholder : "None selected";
          }
      }
    },
    mounted() {
      this.filteredOptions = JSON.parse(JSON.stringify(this.input_options));
      if(this.dropdown){
        $("#collapseSection" + this.cFieldId).click((e) => { e.stopPropagation(); })
      }else{
          $("#collapseSection" + this.cFieldId).on('hidden.bs.collapse',  () => {
          this.cOpen = false;
          this.$emit("onClosed", this.cFieldId);
        });
        $("#collapseSection" + this.cFieldId).on('shown.bs.collapse',  () => {
          this.cOpen = true;
          this.$emit("onOpened", this.cFieldId);
        });
      }
      this.$emit('onMounted', this);
    },
    methods: {
      onKeyPress() {
        this.$emit('onKeyPress', this);
      },
      onBlur() {
        this.$emit('onBlur', this);
      },
      onFocus() {
        this.$emit('onFocus', this);
      },
      onClick() {
        this.$emit('onClick', this);
      },
      newOptionClicked() {
        this.$emit('onNewClick', this);
      },
      selectAllOptions() {
        let data = this.enableSearch && !this.enableDBSearch ? this.filteredOptions : this.input_options;
        this.cValue = data.map((o) => o.value);
        this.$emit('onChange', this);
      },
      clearOptions() {
        this.cValue = [];
        this.$emit('onChange', this);
      },
      sortOptionsSelected() {
        var compare = function (filter) {
          return function (a, b) {
            return (a[filter] === b[filter]) ? 0 : a[filter] ? -1 : 1;
          };
        };
        let data = this.enableSearch && !this.enableDBSearch ? this.filteredOptions : this.input_options;
        data.forEach(f => {
          if (this.cValue.find(i => i == f.value)) {
            f.selected = true;
          } else {
            f.selected = false;
          }
        })
        setTimeout(() => data.sort(compare('selected')), 300);
      }
    },
    data() {
      return {
        filterOptionsSearch: '',
        filteredOptions: [],
        cValue: this.value ? JSON.parse(JSON.stringify(this.value)) : [],
        cOpen: this.open
      }
    }
  }
  </script>
  <style scoped>
  .not-a-link {
    color: black;
  }
  
  .not-a-link:hover {
    color: black;
    text-decoration: none;
  }
  
  .select-field-menu {
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
    transform: unset !important;
    top: auto !important;
    left: auto !important;
  }
  
  .select-field-caption {
    border: 1px solid #ced4da;
    display: block;
    width: 100%;
    background-color: #fff;
    text-align: start;
  }
  
  li {
    list-style-type: none;
  }
  </style>
  